module.exports = __webpack_public_path__ + "img/gibson_sm.8bed3aa6.jpg";